<template>
    <div>
        <fluke-card>
            <header>
                <div class="title">Requisição</div>
                <div class="description">Visualização da requisição</div>
            </header>
            <main>
                <h2>Empresa</h2>
                <br>
                <strong>Nome</strong>: {{ this.request.company }}<br/>
                <strong>CNPJ</strong>: {{ this.request.cnpj }}<br/>
                <br/>
                <br/>

                <h2>Responsável</h2>
                <br/>
                <strong>Nome</strong>: {{ this.request.name }}<br/>
                <strong>Email</strong>: {{ this.request.email }}<br/>
                <strong>Telefone</strong>: {{ this.request.phone }}<br/>
                <br/>
                <br/>

                <h2>Dados</h2>
                <br/>
                <strong>Data</strong>: {{ this.request.createdAt }}<br/>
                <strong>Curso</strong>: {{ this.request.course }}<br/>
                <strong>Estado</strong>: {{ this.request.state }}<br/>
                <strong>Cidade</strong>: {{ this.request.city }}<br/>
            </main>
            <footer v-if="permission.write">
                <fluke-button v-on:click.native="cancel" color="grey">cancelar</fluke-button>
                <fluke-button v-on:click.native="setReadState(true)" v-if="!request.read">Marcar como lido</fluke-button>
                <fluke-button v-on:click.native="setReadState(false)" v-else>Marcar como NÃO lido</fluke-button>
            </footer>
        </fluke-card>
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

import Card from '../../../components/Main/Content/Card/Card.vue';
import Button from '../../../components/Main/Content/Button/Button.vue';

import permission from '../../../mixins/permissions';

export default {
    mixins: [ permission ],
    components: {
        'fluke-card': Card,
        'fluke-button': Button
    },
    data: function() {
        return {
            id: null,
            request: {
                id: '',
                city: '',
                cnpj: '',
                comment: '',
                company: '',
                course: '',
                createdAt: '',
                custom_fields: '',
                email: '',
                name: '',
                phone: '',
                state: '',
                type: '',
                url: ''
            },
            permission: {
                read: false,
                write: false
            }
        }
    },
    created: function(){
        this.getData();
        this.permission = this.getUserPagePermission('blog');
		if( this.permission.read == false ) {
			this.$router.push('/');
		}
    },
    methods: {
        getData: async function(){
            this.id = this.$route.params.id;
            const result = await axios.get(
                this.$myServerAddresses.courses + 'students/request/' + this.id,
                {
                headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
                }
            );
            this.request = result.data;
            this.request.createdAt = moment( this.request.createdAt ).format( 'DD/MM/YYYY' );
            const custom_fields = JSON.parse( this.request.custom_fields );
            for( const field in custom_fields )this.request[field] = custom_fields[field];
            this.request['read'] = ( typeof this.request['read'] == 'undefined' )?false:this.request.read;
        },
        setReadState: async function( value ) {
            var custom_fields = JSON.parse( this.request.custom_fields );
            custom_fields['read'] = value;
            this.request.custom_fields = JSON.stringify( custom_fields );

            const result = await axios.post(
                this.$myServerAddresses.courses + 'students/request/',
                this.request,
                {
                    headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
                }
            );

            // const msg = value?'lida!':'não lida!';

            // this.$store.commit(
            //     'flash_success',
            //     'Request  marcada como ' + msg
            // );

            this.$router.push({ name: 'students' });
        },
        remove: async function () {
            const result = await axios.delete(
				this.$myServerAddresses.blog + 'categories/' + this.id,
                {
                    headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
                }
            );
            this.$router.push({ name: 'blog-categories' });
        },
        cancel() {
            this.$router.push({ name: 'students' });
        }
    }
}
</script>
